import useAZZKURelations from "hooks/AZZKU/useAZZKURelations";
import useAZZKUTopics from "hooks/AZZKU/useAZZKUTopics";

import ExpandableBox from "components/ExpandableBox";
import RadioGroup from "components/RadioGroup";
import ProfessionsForms from "module/AZZKUModule/components/ProfessionsForms";
import TerritorialScaleChoose from "module/AZZKUModule/components/TerritorialScaleChoose";

function RelationsBox({ params, onChange }) {

   const { d: relations_options } = useAZZKURelations( params.variable_id );
   
   return relations_options && relations_options?.length ? (
      <ExpandableBox
         heading="Relacja"
         extra_classes="mini"
      >
         <RadioGroup
            name="relation_id"
            value={ params.relation_id || []}
            buttons={ relations_options }
            onChange={ onChange }
         />
      </ExpandableBox>
   ) : null
}

export default function AZZKUResultsSidebar({ params, onChange }) {

   const { d: topics } = useAZZKUTopics();

   return (
      <div className="azzku-results-sidebar-filters box">

         <ExpandableBox
            extra_classes="mini"
            heading={ <strong style={{ display: "block", textAlign: "right"}}> Zwiń wszystko </strong> }
            style={{ border: 0, padding: 0 }}
         >
            <ExpandableBox 
               default_open
               heading="Dane"
               extra_classes="mini"
            > 
               { topics && !!topics?.length &&
                  topics.map(({ label: topic_name, value: topic_id, variables }) => {
                     return (
                        <ExpandableBox
                           key={ topic_id }
                           heading={ topic_name }
                           default_open={ !!variables.find( v => +v.value === +params.variable_id )}
                           extra_classes="mini mini-inner"
                        >
                           <RadioGroup
                              name={ "variable_id_" + topic_id }
                              value={ params.variable_id }
                              buttons={ variables }
                              onChange={( n, v ) => onChange({
                                 variable_id: v,
                                 relation_id: undefined
                              })}
                           />
                        </ExpandableBox>
                     )
                  })
               }
            </ExpandableBox>

            { params.variable_id && 
               <RelationsBox
                  params={ params }
                  onChange={ onChange }
               />
            }

            <ExpandableBox
               heading="Zawody"
               extra_classes="mini"
               content_style={{ gap: "20px" }}
            >
               <ProfessionsForms
                  hide_text
                  params={ params }
                  onChange={ onChange }
               />
            </ExpandableBox>

            <ExpandableBox
               heading="Obszar"
               extra_classes="mini"
            >
               <TerritorialScaleChoose
                  in_sidebar
                  params={ params }
                  onChange={ onChange }
               />
            </ExpandableBox>

         </ExpandableBox>
      </div>
   )
}